import React, {Component, useEffect} from 'react';
import {StatusBar, Text, View} from 'react-native';
import Navigation from './Navigation';
import {store} from './store/store';
import {Provider} from 'react-redux';
import 'react-native-get-random-values';
import Toast from 'react-native-toast-message';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import './localization/i18n';
import {useTranslation} from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {colors} from './config/theme';
import './config/appHeaders';
import {toastConfig, toastTopOffset} from './components/AppToast';

const App = () => {
  const {i18n} = useTranslation();

  useEffect(() => {
    const getPreferredLanguage = async () => {
      const currLanguage = await AsyncStorage.getItem('languagePreference');
      if (currLanguage) {
        i18n.changeLanguage(currLanguage);
      }
    };
    getPreferredLanguage();
  }, [i18n]);

  return (
    <GestureHandlerRootView style={{flex: 1}}>
      <Provider store={store}>
        <StatusBar
          backgroundColor={colors.background}
          barStyle="dark-content"
        />
        <Navigation />
        <Toast config={toastConfig} topOffset={toastTopOffset} />
      </Provider>
    </GestureHandlerRootView>
  );
};

export default App;
